/**
 * Reusable welcome header component
 * Displays "Welcome to SmartWiz!" with branded styling and description
 * Hidden when all steps are complete to focus on settings cards
 */

import React from "react";
import { Stack, Text, Title } from "@mantine/core";

const COMPLETED = "You have completed all the onboarding steps.";
const PROGRESS =
  "Complete these onboarding steps to revolutionize your tax business!";

interface WelcomeHeaderProps {
  /** Title heading level (1-6), defaults to 2 */
  order?: 1 | 2 | 3 | 4 | 5 | 6;
  /** Additional margin bottom spacing, defaults to "xl" */
  mb?: string;
  /** Whether all onboarding steps are complete */
  allStepsComplete?: boolean;
}

/**
 * Welcome header with SmartWiz branding and description
 */
const WelcomeHeader: React.FC<WelcomeHeaderProps> = ({
  order = 2,
  mb = "xl",
  allStepsComplete = false,
}) => {
  const description = allStepsComplete ? COMPLETED : PROGRESS;

  return (
    <Stack align="center" gap="xs" ta="center" w="100%" mb={mb}>
      <Title order={order}>
        Welcome to{" "}
        <Text span c="#2589ff" inherit>
          SmartWiz!
        </Text>
      </Title>
      <Text size="lg" c="dimmed" maw={600}>
        {description}
      </Text>
    </Stack>
  );
};

export default WelcomeHeader;
